/**
 * Textarea com @menção: ao digitar @ sugere pessoas (nome/e-mail); a pessoa
 * citada recebe alerta no sino com link para o card. Devolve, via
 * `onMencionados`, os ids cujo "@Nome" ainda está no texto.
 */
import React, { useEffect, useState } from 'react';
import { atendimentosAPI } from '../services/api';

let cache = null;

export default function MencaoTextarea({ value, onChange, onMencionados, placeholder, rows = 3, pessoas: pessoasProp, style }) {
  const [pessoas, setPessoas] = useState(pessoasProp || cache || []);
  const [sugestoes, setSugestoes] = useState(null);
  const [citados, setCitados] = useState({});   // id -> nome inserido

  useEffect(() => {
    if (pessoasProp) { setPessoas(pessoasProp); return; }
    if (cache) return;
    atendimentosAPI.mencionaveis().then((r) => { cache = r.data || []; setPessoas(cache); }).catch(() => {});
  }, [pessoasProp]);

  useEffect(() => {
    const ids = Object.entries(citados).filter(([, nome]) => value.includes(`@${nome}`)).map(([id]) => Number(id));
    onMencionados && onMencionados(ids);
  }, [value, citados]);

  const mudar = (e) => {
    const v = e.target.value;
    onChange(v);
    const m = v.slice(0, e.target.selectionStart).match(/@([\wÀ-ÿ.]*)$/);
    if (m) {
      const termo = m[1].toLowerCase();
      setSugestoes(pessoas.filter((u) => (u.nome || '').toLowerCase().includes(termo) || (u.email || '').toLowerCase().includes(termo)).slice(0, 6));
    } else setSugestoes(null);
  };
  const escolher = (u) => {
    const nome = (u.nome || u.email).split(' ').slice(0, 2).join(' ');
    onChange(value.replace(/@([\wÀ-ÿ.]*)$/, `@${nome} `));
    setCitados((c) => ({ ...c, [u.id]: nome }));
    setSugestoes(null);
  };

  return (
    <div style={{ position: 'relative' }}>
      <textarea className="form-control" rows={rows} placeholder={placeholder} value={value} onChange={mudar} style={style} />
      {sugestoes && sugestoes.length > 0 && (
        <div style={{ position: 'absolute', zIndex: 50, left: 0, bottom: '100%', marginBottom: 4, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, boxShadow: '0 6px 18px rgba(0,0,0,.12)', minWidth: 260 }}>
          {sugestoes.map((u) => (
            <div key={u.id} onMouseDown={(e) => { e.preventDefault(); escolher(u); }}
              style={{ padding: '6px 10px', cursor: 'pointer', fontSize: '0.85rem' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#f5f7fa'; }} onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; }}>
              <b>{u.nome}</b> <span style={{ color: '#888', fontSize: '0.75rem' }}>{u.email}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
